import styled from 'styled-components';

const info = styled.button`
  background: transparent;
  border: none;
`;

const Button = {
  Info: info,
};

export default Button;
